import React from 'react';
import useSeo from '../../hooks/useSeo';
import { usePageContent } from './pageContent';
import { LegalSections, PageHero, PageShell } from './blocks';

/* Terms, privacy and cookies. Content: Admin → Landingspagina → <page> (Markdown per section). */
const LegalPage = ({ page, path, testId }) => {
  const { lang, cms, content } = usePageContent(page);

  useSeo({
    path,
    lang,
    title: cms?.seo?.title || `${content.hero.title.replace(/\*/g, '')} | WowProfit.io`,
    description: cms?.seo?.description || content.hero.subtitle,
  });

  return (
    <PageShell testId={testId}>
      <PageHero hero={content.hero} />
      <div className="pb-[clamp(56px,6.6667vw,120px)]">
        <LegalSections sections={content.sections} notice={lang !== 'nl' ? content.notice : null} />
      </div>
    </PageShell>
  );
};

export default LegalPage;
